import {
  match as TMatch,
  matchPath,
  RouteProps,
} from '@jupiter/plugin-runtime/router';

export function matchRoutes<P extends {}>(
  curPathname: string,
  targetPathname: string | Array<string>,
  props?: Pick<RouteProps, 'strict' | 'sensitive' | 'exact'>,
): TMatch<P> | undefined {
  const paths: Array<string> = Array.isArray(targetPathname)
    ? targetPathname
    : [targetPathname];
  for (const path of paths) {
    try {
      const math = matchPath<P>(curPathname, {
        path,
        ...props,
      });
      if (math) {
        return math;
      }
    } catch (e: any) {
      console.info('matchRoutes error', e);
    }
  }
  return undefined;
}
